// extracted by mini-css-extract-plugin
module.exports = {"title":"Charts_title_1USZK","chart":"Charts_chart_3Xsgi","legendItem":"Charts_legendItem_2pR2h"};